import { LocationOn } from '@mui/icons-material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { FC } from 'react'
import { Button } from 'ui'

import styles from './AddressesHeader.module.scss'

interface IAddressesHeader {
  showBack: boolean
  backViewMode?: (arg0: string) => void
}

// header для страницы "/myaddresses"
export const AddressesHeader: FC<IAddressesHeader> = ({
  showBack,
  backViewMode,
}) => {
  const screen = useScreen()

  const showLogo = screen === ScreenEnum.desktop || !showBack

  return (
    <div className={styles.logo_wrapper}>
      {showLogo && (
        <div className={styles.logo}>
          <LocationOn color='primary' />
          <div className='h1'>мои адреса</div>
        </div>
      )}
      {showBack && (
        <Button
          // @ts-ignore
          onClick={backViewMode}
          variant='text'
          className={styles.backButton}
          color='primary'
          data-testid='addresses-back-btn'
          startIcon={
            <ChevronRightIcon
              color='primary'
              className={classNames('rotate180', styles.chevronRight)}
            />
          }
        >
          Назад
        </Button>
      )}
    </div>
  )
}
